export default __webpack_public_path__ + "static/media/backgroundBlur.6de037c5.png";